import React from "react";

/**
 * Minimalist SVG logo for To2casa.com
 * - `variant="full"` renders the house mark + wordmark + tagline
 * - `variant="wordmark"` renders the mark + wordmark only (no tagline)
 * - `variant="icon"` renders only the house mark (for favicon-style contexts)
 * Colors follow the corporate palette:
 *   #0B2545 Azul Marino (primary)
 *   #134074 Azul Celeste (accent)
 *   #8DA9C4 Azul Cielo (soft accent)
 */
export default function Logo({ variant = "full", className = "" }) {
  if (variant === "icon") {
    return (
      <svg
        viewBox="0 0 48 48"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="To2casa"
      >
        <rect width="48" height="48" rx="9" fill="#0B2545" />
        <path
          d="M10 26L24 12L38 26V37C38 37.55 37.55 38 37 38H29V29H19V38H11C10.45 38 10 37.55 10 37V26Z"
          fill="#ffffff"
        />
        <path
          d="M8 27L24 12L40 27"
          stroke="#8DA9C4"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  }

  const withTagline = variant === "full";

  return (
    <svg
      viewBox={withTagline ? "0 0 240 56" : "0 0 220 48"}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="To2casa.com — Tu mercado inmobiliario"
    >
      {/* House mark */}
      <g>
        <path
          d="M6 26L22 10L38 26V44C38 44.55 37.55 45 37 45H29V33H15V45H7C6.45 45 6 44.55 6 44V26Z"
          fill="#0B2545"
        />
        <path
          d="M2 28L22 10L42 28"
          stroke="#134074"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <rect x="19.5" y="17" width="5" height="1.8" fill="#8DA9C4" />
      </g>
      {/* Wordmark */}
      <text
        x="52"
        y={withTagline ? "30" : "32"}
        fontFamily="Manrope, system-ui, sans-serif"
        fontWeight="700"
        fontSize="26"
        letterSpacing="-0.6"
      >
        <tspan fill="#0B2545">to</tspan>
        <tspan fill="#134074">2</tspan>
        <tspan fill="#0B2545">casa</tspan>
        <tspan fill="#8DA9C4" fontSize="14" fontWeight="500">.com</tspan>
      </text>
      {withTagline && (
        <text
          x="53"
          y="46"
          fontFamily="Manrope, system-ui, sans-serif"
          fontWeight="600"
          fontSize="7"
          letterSpacing="2.4"
          fill="#134074"
        >
          TU MERCADO INMOBILIARIO
        </text>
      )}
    </svg>
  );
}
